import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/constants/site";

const inputCls =
  "w-full px-4 py-3 rounded bg-[#0c1427] border border-[#203154] text-white text-sm placeholder-[#4b658d] focus:border-[#38bdf8] focus:outline-none transition-colors";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/login`, form, { withCredentials: true });
      toast.success("Signed in successfully.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-24 bg-[#0c1427]" data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 rounded-xl bg-[#162544] border border-[#203154]">
        <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-2 text-center">
          Restricted Access
        </div>
        <h1 className="text-2xl font-bold text-white text-center mb-6">Admin Sign In</h1>
        <form className="space-y-4" onSubmit={onSubmit} data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-mono text-[#9cb4d8] uppercase mb-1">
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              placeholder="admin email"
              required
              className={inputCls}
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-mono text-[#9cb4d8] uppercase mb-1">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              name="password"
              value={form.password}
              onChange={onChange}
              placeholder="••••••••"
              required
              className={inputCls}
              data-testid="admin-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit-button"
            className="w-full py-3.5 rounded bg-[#38bdf8] text-[#0c1427] font-bold text-xs font-mono uppercase tracking-wider hover:bg-white transition-colors disabled:opacity-60"
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
